<ng-container>

  <div>
    <b>{{ name }}</b>
    <app-info class="formGroupLabel" [wide]="false" [placement]="'left'">
      <div class="tooltipContent">
        <b>Considering</b>
        <ul>
          @for (consider of splitConsidering(); track consider) {
            <div>
              <li>
                {{ consider }}
              </li>
            </div>
          }
        </ul>
      </div>
    </app-info>
  </div>

  <ng-container>
    <div class="row">
      <div class="col-md fieldset">
        <app-visit-exemptions-exemption-common [exemption]="exemption"></app-visit-exemptions-exemption-common>
      </div>
      <div class="col-md fieldset">
        <div class="row">
          <app-form-group label="Reason for request for exemption">
            <app-search [(ngModel)]="exemption.reason" [required] [searchFunction]="searchReasons"
                        placeholder="Select one of the options or type a new one"
                        [newValueFromInputFunction]="newReason" [minCharacters]="0"></app-search>
          </app-form-group>
        </div>

        <div class="row">
          <app-form-group label="Planned force (kN)">
            <input [(ngModel)]="exemption.force" type="number" maxlength="10" class="form-control" required>
          </app-form-group>
          <app-form-group label="Start">
            <app-date-field [(ngModel)]="exemption.from" required></app-date-field>
          </app-form-group>
          <app-form-group label="End">
            <app-date-field [(ngModel)]="exemption.to" required></app-date-field>
          </app-form-group>
        </div>


        <div class="row">
          <app-form-group label="Details">
            <textarea [(ngModel)]="exemption.details" id="details" type="text" rows="3" maxlength="256"
                      class="form-control"></textarea>
          </app-form-group>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
